export const Types = {
  GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_REQUESTED: 'forms/GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_REQUESTED',
  GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_SUCCEEDED: 'forms/GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_SUCCEEDED',
  GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_FAILED: 'forms/GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_FAILED',

  GET_FIELDS_FOR_DEPARTMENTS_REQUESTED: 'forms/GET_FIELDS_FOR_DEPARTMENTS_REQUESTED',
  GET_FIELDS_FOR_DEPARTMENTS_SUCCEEDED: 'forms/GET_FIELDS_FOR_DEPARTMENTS_SUCCEEDED',
  GET_FIELDS_FOR_DEPARTMENTS_FAILED: 'forms/GET_FIELDS_FOR_DEPARTMENTS_FAILED',

  GET_FIELDS_FOR_SECTORS_REQUESTED: 'forms/GET_FIELDS_FOR_SECTORS_REQUESTED',
  GET_FIELDS_FOR_SECTORS_SUCCEEDED: 'forms/GET_FIELDS_FOR_SECTORS_SUCCEEDED',
  GET_FIELDS_FOR_SECTORS_FAILED: 'forms/GET_FIELDS_FOR_SECTORS_FAILED',

  GET_FIELDS_FOR_SERVICES_REQUESTED: 'forms/GET_FIELDS_FOR_SERVICES_REQUESTED',
  GET_FIELDS_FOR_SERVICES_SUCCEEDED: 'forms/GET_FIELDS_FOR_SERVICES_SUCCEEDED',
  GET_FIELDS_FOR_SERVICES_FAILED: 'forms/GET_FIELDS_FOR_SERVICES_FAILED',

  GET_FIELDS_FOR_LEGAL_ENTITIES_REQUESTED: 'forms/GET_FIELDS_FOR_LEGAL_ENTITIES_REQUESTED',
  GET_FIELDS_FOR_LEGAL_ENTITIES_SUCCEEDED: 'forms/GET_FIELDS_FOR_LEGAL_ENTITIES_SUCCEEDED',
  GET_FIELDS_FOR_LEGAL_ENTITIES_FAILED: 'forms/GET_FIELDS_FOR_LEGAL_ENTITIES_FAILED',
}

export function getFieldsForActivitiesBySector() {
  return {
    type: Types.GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_REQUESTED,
  }
}

export function getFieldsForDepartments() {
  return {
    type: Types.GET_FIELDS_FOR_DEPARTMENTS_REQUESTED,
  }
}

export function getFieldsForSectors() {
  return {
    type: Types.GET_FIELDS_FOR_SECTORS_REQUESTED,
  }
}

export function getFieldsForServices() {
  return {
    type: Types.GET_FIELDS_FOR_SERVICES_REQUESTED,
  }
}

export function getFieldsForLegalEntities() {
  return {
    type: Types.GET_FIELDS_FOR_LEGAL_ENTITIES_REQUESTED,
  }
}

const INITIAL_STATE = {
  getFieldsForActivitiesBySectorIsLoading: false,
  getFieldsForActivitiesBySectorError: null,
  fieldsForActivitiesBySector: [],

  getFieldsForDepartmentsIsLoading: false,
  getFieldsForDepartmentsError: null,
  fieldsForDepartments: [],

  getFieldsForSectorsIsLoading: false,
  getFieldsForSectorsError: null,
  fieldsForSectors: [],

  getFieldsForServicesIsLoading: false,
  getFieldsForServicesError: null,
  fieldsForServices: [],

  getFieldsForLegalEntitiesIsLoading: false,
  getFieldsForLegalEntitiesError: null,
  fieldsForLegalEntities: [],
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_REQUESTED:
      return {
        ...state,
        getFieldsForActivitiesBySectorIsLoading: true,
      }
    case Types.GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_SUCCEEDED:
      return {
        ...state,
        getFieldsForActivitiesBySectorIsLoading: false,
        getFieldsForActivitiesBySectorError: null,
        fieldsForActivitiesBySector: action.payload,
      }
    case Types.GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_FAILED:
      return {
        ...state,
        getFieldsForActivitiesBySectorIsLoading: false,
        getFieldsForActivitiesBySectorError: action.payload,
        fieldsForActivitiesBySector: [],
      }

    case Types.GET_FIELDS_FOR_DEPARTMENTS_REQUESTED:
      return {
        ...state,
        getFieldsForDepartmentsIsLoading: true,
      }
    case Types.GET_FIELDS_FOR_DEPARTMENTS_SUCCEEDED:
      return {
        ...state,
        getFieldsForDepartmentsIsLoading: false,
        getFieldsForDepartmentsError: null,
        fieldsForDepartments: action.payload,
      }
    case Types.GET_FIELDS_FOR_DEPARTMENTS_FAILED:
      return {
        ...state,
        getFieldsForDepartmentsIsLoading: false,
        getFieldsForDepartmentsError: action.payload,
        fieldsForDepartments: [],
      }

    case Types.GET_FIELDS_FOR_SECTORS_REQUESTED:
      return {
        ...state,
        getFieldsForSectorsIsLoading: true,
      }
    case Types.GET_FIELDS_FOR_SECTORS_SUCCEEDED:
      return {
        ...state,
        getFieldsForSectorsIsLoading: false,
        getFieldsForSectorsError: null,
        fieldsForSectors: action.payload,
      }
    case Types.GET_FIELDS_FOR_SECTORS_FAILED:
      return {
        ...state,
        getFieldsForSectorsIsLoading: false,
        getFieldsForSectorsError: action.payload,
        fieldsForSectors: [],
      }

    case Types.GET_FIELDS_FOR_SERVICES_REQUESTED:
      return {
        ...state,
        getFieldsForServicesIsLoading: true,
      }
    case Types.GET_FIELDS_FOR_SERVICES_SUCCEEDED:
      return {
        ...state,
        getFieldsForServicesIsLoading: false,
        getFieldsForServicesError: null,
        fieldsForServices: action.payload,
      }
    case Types.GET_FIELDS_FOR_SERVICES_FAILED:
      return {
        ...state,
        getFieldsForServicesIsLoading: false,
        getFieldsForServicesError: action.payload,
        fieldsForServices: [],
      }

    case Types.GET_FIELDS_FOR_LEGAL_ENTITIES_REQUESTED:
      return {
        ...state,
        getFieldsForLegalEntitiesIsLoading: true,
      }
    case Types.GET_FIELDS_FOR_LEGAL_ENTITIES_SUCCEEDED:
      return {
        ...state,
        getFieldsForLegalEntitiesIsLoading: false,
        getFieldsForLegalEntitiesError: null,
        fieldsForLegalEntities: action.payload,
      }
    case Types.GET_FIELDS_FOR_LEGAL_ENTITIES_FAILED:
      return {
        ...state,
        getFieldsForLegalEntitiesIsLoading: false,
        getFieldsForLegalEntitiesError: action.payload,
        fieldsForLegalEntities: [],
      }

    default:
      return state
  }
}
